import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {FillabelFormFilter, FillableForm, FillableFormApiDetailInput, FillableFormInput} from './fillable-form.model';

export const loadFillableForms = createAction(
  '[FillableForm/API] Load FillableForms',
  props<{ fillableForms: FillableForm[] }>()
);

export const addFillableForm = createAction(
  '[FillableForm/API] Add FillableForm',
  props<{ fillableForm: FillableForm }>()
);

export const upsertFillableForm = createAction(
  '[FillableForm/API] Upsert FillableForm',
  props<{ fillableForm: FillableForm }>()
);

export const addFillableForms = createAction(
  '[FillableForm/API] Add FillableForms',
  props<{ fillableForms: FillableForm[] }>()
);

export const upsertFillableForms = createAction(
  '[FillableForm/API] Upsert FillableForms',
  props<{ fillableForms: FillableForm[] }>()
);

export const updateFillableForm = createAction(
  '[FillableForm/API] Update FillableForm',
  props<{ fillableForm: Update<FillableForm> }>()
);

export const updateFillableForms = createAction(
  '[FillableForm/API] Update FillableForms',
  props<{ fillableForms: Update<FillableForm>[] }>()
);

export const deleteFillableForm = createAction(
  '[FillableForm/API] Delete FillableForm',
  props<{ id: string }>()
);

export const deleteFillableForms = createAction(
  '[FillableForm/API] Delete FillableForms',
  props<{ ids: string[] }>()
);

export const clearFillableForms = createAction(
  '[FillableForm/API] Clear FillableForms'
);

// CUSTOM
export const createFillableForms = createAction(
  '[FillableForm/API] create FillableForms',
  props<{ input: FillableFormInput }>()
);


export const editFillableForms = createAction(
  '[FillableForm/API] edit FillableForms',
  props<{ input: FillableFormInput }>()
);


export const removeFillableForms = createAction(
  '[FillableForm/API] remove FillableForms',
  props<{ formUid: string; id: string }>()
);


export const getFillableForms = createAction(
  '[FillableForm/API] get FillableForms',
  props<{ filtering: FillabelFormFilter }>()
);


export const updateConfigurationFillableFormFields = createAction(
  '[FillableFormField/API] update Configuration FillableFormFields',
  props<{ input: {
      uniqueId: string,
      configuration: string
    } }>()
);


export const publishFillableFormFields = createAction(
  '[FillableFormField/API] publish FillableFormFields',
  props<{ input: {
      uniqueId: string,
      published: boolean
    } }>()
);


export const createFillableFormApiDetails = createAction(
  '[FillableFormField/API] create Fillable Form Api Details',
  props<{ input: FillableFormApiDetailInput }>()
);


// CITIZEN
export const citizenGetFillableForms = createAction(
  '[FillableForm/API] citizen get FillableForms',
  props<{ serviceUniqueId: string }>()
);
